import React from "react";
import { adminTheme } from "./adminTheme";

type PageIntroProps = {
  title: string;
  description?: string;
  message?: string;
  children?: React.ReactNode;
};

export default function PageIntro({
  title,
  description,
  message,
  children,
}: PageIntroProps) {
  const body = description ?? message;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: adminTheme.space.sm,
        paddingBottom: "4px",
      }}
    >
      <h1
        style={{
          margin: 0,
          fontSize: adminTheme.type.titleLg,
          lineHeight: 1.1,
          letterSpacing: "-0.03em",
          color: adminTheme.color.text,
        }}
      >
        {title}
      </h1>

      {body ? (
        <p
          style={{
            margin: 0,
            color: adminTheme.color.textMuted,
            lineHeight: 1.7,
            maxWidth: "72ch",
            fontSize: adminTheme.type.bodyLg,
          }}
        >
          {body}
        </p>
      ) : null}

      {children}
    </div>
  );
}